import { inject, Injectable } from '@angular/core';
import {
  TimeSeriesCompact,
  TimeSeriesIndexSummary,
  TimeSeriesInput,
} from '@clean-code/models';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MarketDashboardDetailsDataService {
  private graphqlService = inject(GraphqlService);

  getIndexDetails$(
    symbol: TimeSeriesInput,
    endDate: Date,
  ): Observable<TimeSeriesIndexSummary> {
    const query = `
    query($symbol: TimeSeriesInput!, $endDate: DateTime) {
      timeSeriesIndexSummary(symbol: $symbol, endDate: $endDate){
        deliveryDay
        priceDetails
        {
          intradayPrice
          intradayDateTime
          intradayChange
          yearHigh
          yearLow
          firstDayOfYear
          firstDayOfYearDiff
          oneYearHigh
          oneYearLow
          oneYearChangeDate
          oneYearChange
          unit
          lastClosingPrice
          lastClosingDate
          closingChange
          secondLastClosingPrice
          secondLastClosingDate
        }
        volumeDetails {
          previewDayVolume
          diff
        }
      }
    }`;

    return this.graphqlService.query<TimeSeriesIndexSummary>(query, {
      symbol: symbol.identifier,
      endDate,
    });
  }

  getCompactIndexDetails$(
    symbol: TimeSeriesInput,
    endDate: Date,
  ): Observable<TimeSeriesCompact> {
    const query = `
    query($symbol: TimeSeriesInput!, $endDate: DateTime) {
      timeSeriesIndexCompactSummary(symbol: $symbol, endDate: $endDate){
        deliveryDay
        currentValue
        currentValueDate
        previousValue
        previousValueDate
        differenceRelative
        differenceAbsolute
        unit
      }
    }`;

    return this.graphqlService.query<TimeSeriesCompact>(query, {
      symbol: symbol.identifier,
      endDate,
    });
  }
}
